import styled from '@emotion/styled'
import { useLocale } from '../../../hooks/useLocale'
import { colors } from '../../../styles/theme'

type Props = {}

export const ProfileCardEditorDescription: React.FC<Props> = () => {
  const { t } = useLocale()
  return (
    <DescriptionCard>
      <OrderedList>
        <List>{t.いろんな種類の中から好きなカードを選ぼう}</List>
        <List>
          {
            t.名前やIDよく使うキャラなどあなたのことがみんなにわかるように項目を埋めよう
          }
        </List>
        <List>
          {t.完成したらXにシェアしてみよう友だちが見つかりやすくなるよ}
        </List>
      </OrderedList>
      <H2Text>{t.推奨環境}</H2Text>
      <H2Text>
        {
          t.プライベートブラウザやアドブロッカーを有効にしているとカードの作成に失敗することがあります
        }
      </H2Text>
    </DescriptionCard>
  )
}

const H2Text = styled.h2`
  margin-top: 20px;
  font-size: 11px;
  color: ${colors.text.secondary};
  line-height: 18px;
  display: flex;
`

const DescriptionCard = styled.div`
  margin-top: 12px;
  background-color: #e5e5e5;
  padding: 12px;
  border-radius: 12px;
`

const OrderedList = styled.ol``

const List = styled.li`
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: #4c4c4c;
`
